// result-verifier-head-check.ts
//
// Split out of result-verifier.ts (was 208 lines, over the 200-line budget —
// review 260909-p6-m2 INFO). Owns verifier steps 1-2 only: wait-for-reap +
// "HEAD must not have moved unexpectedly" (covers a forbidden worker commit
// too — an `--allow-empty` commit moves HEAD without changing tree content,
// so identity comparison, not a tree-only diff, is required). Checked BEFORE
// binding cleanup so a worker-commit recovering verdict never deletes the
// binding (§9.4: "phát hiện commit của worker => RECOVERING, không xoá gì").

import { spawnAsyncCapture } from "../spawn-async-capture-with-timeout.js";

export async function gitRevParseHead(repoDir: string): Promise<string> {
  const res = await spawnAsyncCapture("git", ["rev-parse", "HEAD"], {
    cwd: repoDir,
    timeoutMs: 30_000,
    forwardSigint: false,
  });
  return res.stdout.trim();
}

export async function detectUnexpectedHeadChange(
  repoDir: string,
  baselineHeadSha: string,
): Promise<boolean> {
  const currentHead = await gitRevParseHead(repoDir);
  return currentHead !== baselineHeadSha;
}
